import { connect } from 'react-redux';
import type { ProductGraph } from 'state/product-description/model';
import { getIsUserInternal } from 'state/selectors/common/user';
import type { AppState } from 'state/state.model';

import productDescriptionAdvanced from './Phoenix_Advanced.json' with { type: 'json' };
import productDescriptionSimplified from './Phoenix_Simplified.json' with { type: 'json' };

interface StateProps {
  isInternalUser: boolean;
  product: string;
  productDescription: ProductGraph;
}

export type MainFormSkeletonProps = StateProps;

const mapStateToProps = (state: AppState): StateProps => {
  const isInternalUser = getIsUserInternal(state);
  const productDescription = (
    isInternalUser ? productDescriptionAdvanced : productDescriptionSimplified
  ) as ProductGraph;
  return {
    isInternalUser,
    product: 'Phoenix',
    productDescription,
  };
};

export const connectMainSkeletonForm = connect(mapStateToProps);
